/* eslint camelcase: ["error", {allow: ["websys_lu","websys_createWindow","websys_MainWin","websys_getWinHeight","websys_getWinWidth","websys_getMainFrame"]}] */
'use strict';

/**
* @ngdoc service
* @name tcApp:MenuCheckService
* @description
* Service that runs action menu functions
*/
angular.module('tcApp')
.service('MenuCheckService', function($window, $log, $http, $q,
										GlobalService, LegacyScopeService, TkLibService, ComponentScriptService) {
	var MenuCheckService = this;
	// Stores the state any warnings that should only display once
	MenuCheckService.warningsGiven = {};

	// Sets up the environment to be able to run any menu check functions and runs them
	this.checkMenu = function(menu, actionMenuScope) {
		if (angular.isUndefined(menu)) return;
		if (angular.isUndefined(menu.jsCheckFunction)) return;
		var checkReturnValue = true;
		var ranFunction = false;

		// Populate the variables needed in scope by the menu check functions
		frm = getFormObject(actionMenuScope.data);
		document.forms['fEPRMENU'] = frm; //eslint-disable-line
		top.frames.eprmenu.document = document; //eslint-disable-line
		t = GlobalService.getGlobalStrings();
		try {
			var rawParameters = '';
			if (angular.isDefined(actionMenuScope.data.listRow)) {
				if (angular.isDefined(actionMenuScope.data.listRow['_passParametersRaw'])) {
					rawParameters = (actionMenuScope.data.listRow['_passParametersRaw']);
				} else {
					// Fallback to encoded parameters if raw parameters is not defined for custom action menus
					rawParameters = (actionMenuScope.data.listRow['_passParameters'] || '');
					if (rawParameters !== '') rawParameters = ('?' + rawParameters);
				}
			}
			lnk = (rawParameters || '');
			if (this.hasValueExpressionParams(menu)) {
				lnk = lnk + menu.valueExpressionParams;
			}
			// Region level functions are attached to the service scope, but do not include CheckLinkDetails/PassDetails
			if ((['CheckLinkDetails','PassDetails'].indexOf(menu.jsCheckFunction) === -1)
				&& (angular.isFunction(MenuCheckService[menu.jsCheckFunction]))) {
				checkReturnValue = MenuCheckService[menu.jsCheckFunction].call(MenuCheckService, lnk, '', '', '');
				ranFunction = true;
			} else if (angular.isFunction(this.checkFunctions[menu.jsCheckFunction])) {
				checkReturnValue = this.checkFunctions[menu.jsCheckFunction](lnk);
				ranFunction = true;
			}
			if ((ranFunction) && (checkReturnValue !== false)) {
				// 'lnk' variable can be added to by the check function.
				// Mask the new parameters if 'lnk' was modified
				if ((lnk !== '') && (lnk !== rawParameters)) {
					if (lnk.indexOf('?TUID=') !== 0) {
						// Re-arrange newly appended parameters to override existing ones and apply URL encoding
						// Only do this where 'lnk' is not already TUID encoded, otherwise the existing parameters will be lost
						lnk = ('?' + encodeURI(lnk.substr(rawParameters.length + 1))
							+ (rawParameters.length ? ('&' + lnk.substr(1, rawParameters.length - 1)) : '')
						);
					}
					lnk = GlobalService.maskUrl(lnk);
					lnk = lnk.split('?')[1];
				} else {
					lnk = actionMenuScope.data.listRow['_passParameters'];
				}
			} else {
				lnk = actionMenuScope.data.listRow['_passParameters'];
			}
			return checkReturnValue;
		} catch (ex) {
			// Log any error, but allow navigation to continue
			$log.error(ex);
		}

		return true;
	};

	// Returns the link parameters that could have been modified by the menu check function
	this.getMenuLinkParams = function() {
		return lnk;
	};

	// Returns if the menu has ValueExpression parameters that need to be passed
	// Patient Banner is managed by the framework, ignore value expression if this is the only parameter
	this.hasValueExpressionParams = function(menu) {
		return (angular.isDefined(menu)
			&& (angular.isDefined(menu.valueExpressionParams))
			&& (menu.valueExpressionParams !== '')
			&& (menu.valueExpressionParams !== '&PatientBanner=1'));
	};

	// Expose a limited set of variables to the scope for executing custom check functions
	var getLocalVariableList = function() {
		var variables = {};
		variables.t = 'GlobalService.getGlobalStrings()';
		['top','tkMakeServerCall','document','mPiece', //eslint-disable-line
		'CheckLinkDetails','PassDetails','websys_lu','websys_createWindow','websys_getMainFrame',
		'websys_getWinWidth','websys_getWinHeight','websys_MainWin','session'].forEach(function(variableName) {
			variables[variableName] = ('this.' + variableName);
		});

		return variables;
	};

	var runScripts = function($scope, source) {
		var functionName = 'menuScript' + $scope.$id;
		var localVariables = getLocalVariableList();
		// Use the same logic as components to parse the script function
		var scriptFunction = ComponentScriptService.getScriptFunction($scope, functionName, source,
																	'GlobalService,TkLibService', localVariables);
		$window.tcEvalNonStrictMode(scriptFunction);

		// tkLib will attach any functions to the MenuCheckService scope
		$window[functionName].call(MenuCheckService, GlobalService, TkLibService);
		delete $window[functionName];
	};

	// Allows the use of a the region level menu script if one exists
	this.applyScripts = function(actionMenuScope, scripts) {
		var httpPromises = [];
		var httpConfig = {cache: true};
		angular.forEach(scripts, function(value) {
			httpPromises.push($http.get(value, httpConfig));
		});
		$q.all(httpPromises).then(function(results) {
			// Apply legacy functions to scope
			var allScripts = '';
			angular.forEach(results, function(value) {
				allScripts += '\n\n//////////////////////\n// ' + value.config.url + '\n//////////////////////\n\n';
				allScripts += value.data + '\n';
			});

			runScripts(actionMenuScope, allScripts);
		});
	};

	// Form object names to emulate the epr.menu.csp environment
	var actionMenuPassParams = function() {
		return ['PatientID','EpisodeID','mradm','MultiEpisodeID','MultiPatientID','Decease','MultipleIDs',
				/* Orders: */ 'OEOrdItemID','EpisodeType','OEORIItemStatus','UNAUTH','ARCIMDesc', 'OS',
				/* Appointments/OT: */ 'apptID','ApptID','ApptStatus','ItemApptStatus','AnaesthesiaID','OperRoomID',
				/* Waiting List: */ 'WaitingListID','WLWaitListStatusDR','WLStatusDRs',
				/* Radiology/Results: */ 'RWBResStat','RWBNSR','TextCodes','SameResult','PreventMultiResultTypes',
				/* Billing/Other: */ 'BillRowIds', 'BillTypes', 'attendID', 'ContactID',
				/* PAS */ 'WardID','PAAdmCodingID','NokID','EventTimeID','SinglePatientFlag','canGiveBirth','ChildbearingAge',
				/* Lab */ 'LBEpisodeID'];
	};
	this.actionMenuPassParams = actionMenuPassParams;

	// Creates the form object to emulate the epr.menu.csp environment
	var getFormObject = function(actionMenuData) {
		var formObject = angular.copy(actionMenuData.listRow);
		var formProperties = actionMenuPassParams();

		// Fill out any missing properties with blank values
		formProperties.forEach(function(formProperty) { //eslint-disable-line
			if (angular.isUndefined(formObject[formProperty])) {
				formObject[formProperty] = {value: ''};
			} else if (!angular.isObject(formObject[formProperty])) {
				// Massage into an object for existing string values
				formObject[formProperty] = {value: formObject[formProperty]};
			}
		});
		// Manual transformations, as per websys.list.js => epr.frames.csp
		if (angular.isDefined(formObject['OrderID']) && (formObject['OEOrdItemID'].value === '')) {
			formObject['OEOrdItemID'] = formObject['OrderID'];
		}
		if (angular.isDefined(formObject['ItemStatusCode'])) formObject['OEORIItemStatus'] = formObject['ItemStatusCode'];
		if ((angular.isDefined(formObject['admtype'])) || (angular.isDefined(formObject['admType']))) {
			formObject['EpisodeType'] = (formObject['admtype'] || (formObject['admType']));
		}
		if (angular.isDefined(formObject['NOK_RowId']) && (formObject['NokID'].value === '')) {
			formObject['NokID'] = formObject['NOK_RowId'];
		}
		if ((angular.isDefined(formObject['OEORIAPPTDR'])) && (formObject['OEORIAPPTDR'].value !== '')) {
			formObject['apptID'].value = formObject['ApptID'].value = formObject['OEORIAPPTDR'].value.split('^')[0];
		}
		if ((formObject['ApptID'].value !== '') && (formObject['apptID'].value === '')) {
			formObject['apptID'].value = formObject['ApptID'].value;
		}
		if (angular.isDefined(formObject['EventSessId'])) formObject['EventTimeID'] = formObject['EventSessId'];
		if ((angular.isDefined(formObject['APPT_StatusCode'])) || (angular.isDefined(formObject['StatusCode']))) {
			formObject['ApptStatus'] = (formObject['APPT_StatusCode'] || (formObject['StatusCode']));
		}
		if (angular.isDefined(formObject['RadStatusCode'])) formObject['OEORIItemStatus'] = formObject['RadStatusCode'];

		return formObject;
	};

	// Utilities and required legacy scope variables
	var frm = {};
	var t = {};
	var lnk = '';
	var newwin = ''; //eslint-disable-line
	var document = {forms: {fEPRMENU: ''}};
	this.document = document;
	var mPiece = function(delimitedString, delimiter, piece) {
		if (angular.isUndefined(delimitedString)) return '';
		return (delimitedString.split(delimiter)[piece] || '');
	};
	this.mPiece = mPiece;
	var PassDetails = function() { return true; }; //eslint-disable-line
	this.PassDetails = PassDetails;
	var CheckLinkDetails = function() { return true; }; //eslint-disable-line
	this.CheckLinkDetails = CheckLinkDetails;
	var top = {frames: {location: {}, eprmenu: {document: document}}, HideTools: function() {}}; //eslint-disable-line
	this.top = top;
	var websys_lu = function() {}; //eslint-disable-line
	this.websys_lu = websys_lu;
	var websys_createWindow = function() {}; //eslint-disable-line
	this.websys_createWindow = websys_createWindow;
	var websys_getMainFrame = function() {};
	this.websys_getMainFrame = websys_getMainFrame;
	var websys_getWinHeight = function() { return '0'; };
	this.websys_getWinHeight = websys_getWinHeight;
	var websys_getWinWidth = function() { return '0'; };
	this.websys_getWinWidth = websys_getWinWidth;
	var websys_MainWin = {};
	this.websys_MainWin = websys_MainWin;
	var session = LegacyScopeService.getSession(GlobalService);
	this.session = session;

	// Mostly the same as websys.js, but does not support options object as the first argument
	var tkMakeServerCall = function(className, method) { //eslint-disable-line
		if (angular.isObject(className)) {
			$log.warn('Options object is not supported for tkMakeServerCall in menu functions');
			return '';
		}
		var args = Array.prototype.slice.apply(arguments);
		args.unshift(GlobalService.serverMethods[0], 'tkMakeServerCall');
		var returnValue = $window.cspHttpServerMethod.apply(this, args);
		try {
			var returnObj = angular.fromJson(returnValue);
			if (angular.isDefined(returnObj.returnValue)) {
				return returnObj.returnValue;
			} else {
				return '';
			}
		} catch (ex) {
			if (returnValue === '<TC.ERROR>') {
				$log.error('MenuCheckService: tkMakeServerCall: ', GlobalService.getGlobalStrings()['XERROR']);
			} else {
				$log.error('MenuCheckService: tkMakeServerCall: Failed to parse server call response');
			}
			return returnValue;
		}
	};
	this.tkMakeServerCall = tkMakeServerCall;

	// Library of supported functions, adapted from epr.menu.js

	var checkLinkDetailsMulti = function() {
		var tempEpis = mPiece(frm.MultiEpisodeID.value, '^', 1);
		if (tempEpis != '') {
			if (!$window.confirm(t['EPIS_MULTI'])) return false;
		}

		return true;
	};

	var checkOrderItemDetails = function() {
		if (/D/i.test(frm.OEORIItemStatus.value)) {
			$window.alert(t['DiscontinuedOrder']);
			return false;
		}
		if (/Y/i.test(frm.Decease.value)) {
			if (!$window.confirm(t['PAT_DECEASED'])) return false;
		}
		lnk += '&OEOrdItemID=' + frm.OEOrdItemID.value;
		if (/Y/i.test(frm.OEORIItemStatus.value)) { lnk += '&ReadOnly=1';}
		return true;
	};

	var checkLinkDetailsVoice = function() {
		var ItmStat = '';
		var i = 0;
		while (mPiece(frm.OEORIItemStatus.value, '^', i) != '') {
			ItmStat = mPiece(frm.OEORIItemStatus.value, '^', i);
			if ((!/E/i.test(ItmStat))
				&& (!/RESV/i.test(ItmStat))
				&& (!/TYP/i.test(ItmStat))) {
				$window.alert(t['NotExecuted']);
				return false;
			}
			i += 1;
		}
		var firstat = mPiece(frm.OEORIItemStatus.value, '^', 0);
		for (i = 0; mPiece(frm.OEORIItemStatus.value, '^', i) != ''; i++) {
			if (firstat != mPiece(frm.OEORIItemStatus.value, '^', i)) {
				$window.alert(t['SameStatus']);
				return false;
			}
		}
		lnk += ('&OEOrdItemID=' + frm.OEOrdItemID.value + '&allOEIDsToLoop='
			+ frm.OEOrdItemID.value + '&OEItemStatus=' + frm.OEORIItemStatus.value);
		return true;
	};

	var checkLinkDetailsBatchVoice = function() {
		var ordStr = '';
		var ItmStat = '';
		var i = 0;
		var allExe = 1;
		while (mPiece(frm.OEORIItemStatus.value, '^', i) != '') {
			ItmStat = mPiece(frm.OEORIItemStatus.value, '^', i);

			if (ItmStat != 'E') {
				allExe = 0;
			} else {
				ordStr = ordStr + mPiece(frm.OEOrdItemID.value, '^', i) + '^';
			}
			i += 1;
		}

		if (ordStr == '') {
			$window.alert(t['NoneExecuted']);
			return false;
		}
		if (!allExe) $window.alert(t['NotInBatchDic']);
		lnk += '&OEOrdItemID=' + ordStr + '&allOEIDsToLoop=' + ordStr
			+ '&OEItemStatus=' + frm.OEORIItemStatus.value;

		return true;
	};

	var checkLinkDetailsBatchText = function() {
		var ordStr = '';
		var ItmStat = '';
		var i = 0;
		var allRep = 1;

		var pattern = new Array('^AUTH^','^S^','^V^','^H^','^D^','^DNA^','^WL^','^W^','^IP^');
		var patt = '';
		var ItemStatus = '^' + frm.OEORIItemStatus.value + '^';
		if (frm.OEOrdItemID.value != '') {
			for (i = 0; i < pattern.length; i++) {
				patt = pattern[i];
				if (ItemStatus.indexOf(patt) != -1) {
					allRep = 0;
				} else {
					ItmStat = mPiece(frm.OEORIItemStatus.value, '^', i);
					if ((ItmStat == 'REP') || (ItmStat == 'E')) ordStr = ordStr + mPiece(frm.OEOrdItemID.value, '^', i) + '^';
				}
			}
		}
		var RWBResStat = frm['RWBResStat'].value;
		var RWBNSR = frm['RWBNSR'].value;
		for (i = 0; i < RWBResStat.length; i++) {
			if (RWBResStat.substr(i, 1) == 'W') {
				if (RWBNSR.substr(i, 1) != 'Y') {
					$window.alert(t['WordResultExists']);
					return false;
				}
			}
		}
		if (ordStr == '') {
			$window.alert(t['NoneReported']);
			return false;
		}
		if (!allRep) $window.alert(t['NotInBatchTrans']);

		lnk += '&OEOrdItemID=' + ordStr + '&allOEIDsToLoop=' + ordStr
				+ '&OEItemStatus=' + frm.OEORIItemStatus.value + '&Action=X';
		return true;
	};

	var checkLinkDetailsforWordDoc = function() {
		var pattern = new Array('^AUTH^','^S^','^V^','^H^','^D^','^DNA^','^WL^','^W^','^IP^');
		var patt = '';
		var ItemStatus = ('^' + frm.OEORIItemStatus.value + '^');
		var i;
		if (frm.OEOrdItemID.value != '') {
			for (i = 0; i < pattern.length; i++) {
				patt = pattern[i];
				if (ItemStatus.indexOf(patt) != -1) {
					$window.alert(t['NotReported']);
					return false;
				}
			}
		}
		var firstat = mPiece(frm.OEORIItemStatus.value, '^', 0);
		for (i = 0; mPiece(frm.OEORIItemStatus.value, '^', i) != ''; i++) {
			if (firstat != mPiece(frm.OEORIItemStatus.value, '^', i)) {
				$window.alert(t['SameStatus']);
				return false;
			}
		}
		// Log 51886 - AI - 11-05-2005 : Finally, check that this is not already a "... Text" Result.
		var RWBResStat = frm['RWBResStat'].value;
		if (RWBResStat.indexOf('T') != -1) {
			$window.alert(t['TextResultExists']);
			return false;
		}

		var SameResult = frm['SameResult'].value;
		if (SameResult === 0) {
			$window.alert(t['DiffResult']);
			return false;
		}

		lnk += '&OEOrdItemID=' + frm.OEOrdItemID.value + '&allOEIDsToLoop='
				+ frm.OEOrdItemID.value + '&OEItemStatus=' + frm.OEORIItemStatus.value;
		return true;
	};

	var checkLinkDetailsforFastWordDoc = function() {
		var firstat = mPiece(frm.OEORIItemStatus.value, '^', 0);
		for (var i = 0; mPiece(frm.OEORIItemStatus.value, '^', i) != ''; i++) {
			if (firstat != mPiece(frm.OEORIItemStatus.value, '^', i)) {
				$window.alert(t['SameStatus']);
				return false;
			}
		}
		// Log 51886 - AI - 11-05-2005 : Finally, check that this is not already a "... Text" Result.
		var RWBResStat = frm['RWBResStat'].value;
		if (RWBResStat.indexOf('T') != -1) {
			$window.alert(t['TextResultExists']);
			return false;
		}
		lnk += '&execute=1&OEOrdItemID=' + frm.OEOrdItemID.value + '&allOEIDsToLoop='
			+ frm.OEOrdItemID.value + '&OEItemStatus=' + frm.OEORIItemStatus.value;
		return true;
	};

	var checkLinkDetailsforWordDocVerify = function() {
		var pattern = new Array('^AUTH^','^S^','^V^','^H^','^D^','^DNA^','^WL^','^W^','^IP^','^E^','^REP^','^RESV^');
		var patt = '';
		var ItemStatus = '^' + frm.OEORIItemStatus.value + '^';
		var i;
		if (frm.OEOrdItemID.value != '') {
			for (i = 0; i < pattern.length; i++) {
				patt = pattern[i];
				if (ItemStatus.indexOf(patt) != -1) {
					$window.alert(t['NotTyped']);
					return false;
				}
			}
		}
		var firstat = mPiece(frm.OEORIItemStatus.value, '^', 0);
		for (i = 0; mPiece(frm.OEORIItemStatus.value, '^', i) != ''; i++) {
			if (firstat != mPiece(frm.OEORIItemStatus.value, '^', i)) {
				$window.alert(t['SameStatus']);
				return false;
			}
		}

		// Log 51886 - AI - 11-05-2005 : Finally, check that this is not already a "... Text" Result.
		var RWBResStat = frm['RWBResStat'].value;
		if (RWBResStat.indexOf('T') != -1) {
			$window.alert(t['TextResultExists']);
			return false;
		}
		// end Log 51886
		lnk += '&OEOrdItemID=' + frm.OEOrdItemID.value + '&allOEIDsToLoop=' + frm.OEOrdItemID.value;
		return true;
	};

	var checkLinkDetailsforText = function() {
		var pattern = new Array('^AUTH^','^S^','^V^','^H^','^D^','^DNA^','^WL^','^W^','^IP^');
		var patt = '';
		var ItemStatus = '^' + frm.OEORIItemStatus.value + '^';
		var i;
		if (frm.OEOrdItemID.value != '') {
			for (i = 0; i < pattern.length; i++) {
				patt = pattern[i];
				if (ItemStatus.indexOf(patt) != -1) {
					$window.alert(t['NotReported']);
					return false;
				}
			}
		}

		var RWBResStat = frm['RWBResStat'].value;
		var RWBNSR = frm['RWBNSR'].value;
		for (i = 0; i < RWBResStat.length; i++) {
			if (RWBResStat.substr(i, 1) == 'W') {
				if (RWBNSR.substr(i, 1) != 'Y') {
					$window.alert(t['WordResultExists']);
					return false;
				}
			}
		}

		var SameResult = frm['SameResult'].value;
		if (SameResult === 0) {
			$window.alert(t['DIFF_DICT']);
			return false;
		}

		lnk += '&OEOrdItemID=' + frm.OEOrdItemID.value + '&allOEIDsToLoop=' + frm.OEOrdItemID.value
			+ '&OEItemStatus=' + frm.OEORIItemStatus.value + '&Action=X&TextCodes=' + frm['TextCodes'].value;
		return true;
	};

	var checkLinkDetailsforFastText = function() {
		var RWBResStat = frm['RWBResStat'].value;
		var RWBNSR = frm['RWBNSR'].value;
		var i;
		for (i = 0; i < RWBResStat.length; i++) {
			if (RWBResStat.substr(i, 1) == 'W') {
				if (RWBNSR.substr(i, 1) != 'Y') {
					$window.alert(t['WordResultExists']);
					return false;
				}
			}
		}
		var PreventMultiResultTypes = frm['PreventMultiResultTypes'].value;
		if (PreventMultiResultTypes === 'Y') {
			for (i = 0; i < RWBResStat.length; i++) {
				if (RWBResStat.substr(i, 1) == 'Q') {
					$window.alert(t['QuestionnaireResultExists']);
					return false;
				}
			}
		}

		lnk += '&execute=1&OEOrdItemID=' + frm.OEOrdItemID.value + '&allOEIDsToLoop=' + frm.OEOrdItemID.value
			+ '&OEItemStatus=' + frm.OEORIItemStatus.value + '&Action=X&TextCodes=' + frm['TextCodes'].value;
		return true;
	};

	var checkLinkDetailsforFastQuest = function() {
		var RWBResStat = frm['RWBResStat'].value;
		var RWBNSR = frm['RWBNSR'].value;
		var i;
		for (i = 0; i < RWBResStat.length; i++) {
			if (RWBResStat.substr(i, 1) == 'W') {
				if (RWBNSR.substr(i, 1) != 'Y') {
					$window.alert(t['WordResultExists']);
					return false;
				}
			}
		}
		var PreventMultiResultTypes = frm['PreventMultiResultTypes'].value;
		if (PreventMultiResultTypes === 'Y') {
			for (i = 0; i < RWBResStat.length; i++) {
				if (RWBResStat.substr(i, 1) == 'T') {
					$window.alert(t['TextResultExists']);
					return false;
				}
			}
		}
		lnk += '&execute=1&OEOrdItemID=' + frm.OEOrdItemID.value + '&allOEIDsToLoop=' + frm.OEOrdItemID.value
			+ '&OEItemStatus=' + frm.OEORIItemStatus.value + '&Action=X&TextCodes=' + frm['TextCodes'].value;
		return true;
	};

	var checkLinkDetailsforTextVerify = function() {
		var i;
		var pattern = '^TYP^';
		var ItemStatus = '^' + frm.OEORIItemStatus.value + '^';
		if (ItemStatus.indexOf(pattern) == -1) {
			$window.alert(t['NotTyped']);
			return false;
		}

		// Log 61269 - AI - 19-10-2006 : Add this check as per Word Verify (CheckLinkDetailsforWordDocVerify).
		var firstat = mPiece(frm.OEORIItemStatus.value, '^', 0);
		for (i = 0; mPiece(frm.OEORIItemStatus.value, '^', i) != ''; i++) {
			if (firstat != mPiece(frm.OEORIItemStatus.value, '^', i)) {
				$window.alert(t['SameStatus']);
				return false;
			}
		}
		var RWBResStat = frm['RWBResStat'].value;
		var RWBNSR = frm['RWBNSR'].value;
		for (i = 0; i < RWBResStat.length; i++) {
			if (RWBResStat.substr(i, 1) == 'W') {
				if (RWBNSR.substr(i, 1) != 'Y') {
					$window.alert(t['WordResultExists']);
					return false;
				}
			}
		}

		lnk += '&OEOrdItemID=' + frm.OEOrdItemID.value + '&allOEIDsToLoop='
			+ frm.OEOrdItemID.value + '&Action=Y' + '&TextCodes=' + frm['TextCodes'].value;
		return true;
	};

	var checkLinkDetailsforDelivery = function() {
		if (mPiece(frm.OEOrdItemID.value, '^', 1) != '') {
			$window.alert(t['DeliveryMultipleOrders']);
			return false;
		}
		var pattern = '^RESV^';
		var ItemStatus = '^' + frm.OEORIItemStatus.value + '^';
		if (ItemStatus.indexOf(pattern) == -1) {
			$window.alert(t['NotVerified']);
			return false;
		}
		lnk += '&OEOrdItemID=' + frm.OEOrdItemID.value + '&allOEIDsToLoop=' + frm.OEOrdItemID.value + '&Action=Y';
		return true;
	};

	var checkWLAddDetails = function() {
		// RQG 06.01.03 Log30995 To restrict multiple selection of order items
		if (mPiece(frm.OEOrdItemID.value, '^', 1) != '') {
			$window.alert(t['MultipleOrder']);
			return false;
		}
		if (frm['OS'].value == 'DIFFERENT') {
			$window.alert(t['DiffOrderSubCateg']);
			return false;
		}
		if (/D/i.test(frm.OEORIItemStatus.value)) {
			$window.alert(t['DiscontinuedOrder']);
			return false;
		}
		if (/E/i.test(frm.OEORIItemStatus.value)) {
			$window.alert(t['ExecutedOrder']);
			return false;
		}
		if (/REP/i.test(frm.OEORIItemStatus.value)) {
			$window.alert(t['ExecutedOrder']);
			return false;
		}
		if (/TYP/i.test(frm.OEORIItemStatus.value)) {
			$window.alert(t['ExecutedOrder']);
			return false;
		}
		if (/RESV/i.test(frm.OEORIItemStatus.value)) {
			$window.alert(t['ExecutedOrder']);
			return false;
		}
		if (/IP/i.test(frm.OEORIItemStatus.value)) {
			$window.alert(t['ExecutedOrder']);
			return false;
		}
		//Log 34932 - Ajiw 15/4/03 - should also allow for cancelled appointments->(X)
		if (frm.ItemApptStatus.value != '' && frm.ItemApptStatus.value != 'X') {
			$window.alert(t['APPTWLADD']);
			return false;
		}
		if (/Y/i.test(frm.Decease.value)) {
			if (!$window.confirm(t['PAT_DECEASED'])) return false;
		}
		lnk += '&OEOrdItemID=' + frm.OEOrdItemID.value;
		if (/Y/i.test(frm.OEORIItemStatus.value)) {
			lnk += '&ReadOnly=1';
		}
		return true;
	};

	var executeOrderQuantity = function() {
		var pattern = frm.OEORIItemStatus.value;
		var countE = 0;
		var len = pattern.length;
		var strArray = pattern.split(' ');
		var splitlen = strArray.length || 0;
		for (var i = 0; i < len; i++) {
			if (pattern.charAt(i) == 'E') countE ++;
		}
		if (countE > 1) return false;
		if (countE > 0 && splitlen > 2) {
			return false;
		}
		return true;
	};

	var checkOrderItemAndSubCategory = function() {
		if (!executeOrderQuantity()) {
			$window.alert(t['MultipleExecute']);
			return false;
		}
		if (frm.WLWaitListStatusDR.value == 'S') {
			$window.alert(t['SuspendedWL']);
			return false;
		}
		if (/D/i.test(frm.OEORIItemStatus.value)) {
			$window.alert(t['DiscontinuedOrder']);
			return false;
		}

		if (/Y/i.test(frm.Decease.value)) {
			if (!$window.confirm(t['PAT_DECEASED'])) return false;
		}

		lnk += '&OEOrdItemID=' + frm.OEOrdItemID.value + '&allOEIDsToLoop=' + frm.OEOrdItemID.value
			+ '&OrdIDtoTranscribe=' + frm.OEOrdItemID.value;

		var AllAtOnce = 1;
		if (frm.OEOrdItemID.value.split('^').length > 1) {
			AllAtOnce = $window.confirm(t['AllAtOnce']);
		}
		var OS = frm['OS'].value;
		if (AllAtOnce) {
			var msg = '';
			if (frm.EpisodeID.value == '') {
				msg += t['DiffEpisode'] + '\n';
			}
			if (OS == 'DIFFERENT') {
				msg += t['DiffOrderSubCateg'] + '\n';
			}
			if (msg != '') {
				$window.alert(msg);
				return false;
			}
			lnk += '&AllAtOnce=1&OS=' + OS;
		} else {
			lnk += '&AllAtOnce=0';
		}
		// "If" condition to bypass the Message "Cannot process executed order"
		if (/Y/i.test(frm.OEORIItemStatus.value)) {
			lnk += '&ReadOnly=1';
		}
		return true;
	};

	var checkWaitingListDetails = function() {
		if (/Y/i.test(frm.Decease.value)) {
			if (!$window.confirm(t['PAT_DECEASED'])) return false;
		}
		var err = tkMakeServerCall('web.PAWaitingList', 'CheckWLOnReinstate', frm.WaitingListID.value);
		if (err == 1) {
			$window.alert(t['CantReinstateWL']);
			return false;
		}
		lnk += '&OEOrdItemID=' + frm.OEOrdItemID.value + '&SelectedWaitingListID=' + frm.WaitingListID.value;
		return true;
	};

	var checkEpisodeDetailsforApp = function() {
		if (mPiece(frm.WaitingListID.value, '^', 1) != '') {
			$window.alert(t['SingleWLReq']);
			return false;
		}
		return true;
	};

	var checkWaitingListStatusDetails = function() {
		if ((frm.WLWaitListStatusDR.value != 'I') && (frm.WLWaitListStatusDR.value != 'S')) {
			$window.alert(t['BulkIAndSOnly']);
			return false;
		}
		return true;
	};

	var checkWaitingListOTDetails = function() {
		if (/Y/i.test(frm.Decease.value)) {
			if (!$window.confirm(t['PAT_DECEASED'])) {
				return false;
			}
		}
		if (mPiece(frm.WaitingListID.value, '^', 1) != '') {
			$window.alert(t['SingleWLReq']);
			return false;
		}
		if (frm.WLStatusDRs.value != '') {
			var StatList = frm.WLStatusDRs.value.split('||')[0];
			var WLTypes = frm.WLStatusDRs.value.split('||')[1];
			var ret = tkMakeServerCall('web.PAWaitingListAdm', 'CheckActivePreAdm', frm.WaitingListID.value);
			if (((StatList != 'I') && (StatList != 'A') && (StatList != 'S') || (WLTypes != 'I') || (ret == 1))) {
				$window.alert(t['WrongWLTypeorWLorTCIstatus']);
				return false;
			}
		}

		lnk += '&OEOrdItemID=' + frm.OEOrdItemID.value;
		return true;
	};

	var checkNewBornLinkDetails = function() {
		return true;
	};
	
	var checkLabEpisodeDetails = function () {

		if ((angular.isDefined(frm.LBEpisodeID)) && (frm.LBEpisodeID.value!='')) {
			lnk += '&LBEpisodeID='+frm.LBEpisodeID.value;		
		}

		return true;
	};

	var aRPBillCancelSelectedBills = function() {
		var PatientIds = '';
		var EpisodeIds = '';
		var BillRowIds = '';
		var BillType = '';
		var NextBillType = '';
		var i = 1;
		while (mPiece(frm.BillRowIds.value, '^', i) != '') {
			i = i + 1;
		}
		var SelectedRows = i;
		i = 0;
		while (mPiece(frm.BillRowIds.value, '^', i) != '') {
			BillRowIds = BillRowIds + mPiece(frm.BillRowIds.value, '^', i);
			EpisodeIds = EpisodeIds + frm.EpisodeID.value;
			PatientIds = PatientIds + frm.PatientID.value;
			BillType = mPiece(frm.BillTypes.value, '^', i);
			NextBillType = mPiece(frm.BillTypes.value, '^', i);
			if (NextBillType == 'D') {
				//Deposit lines may not be selected
				$window.alert(t['DepSelect'] + ' ' + t['NoDepsBill']);
				return false;
			}
			if (NextBillType == 'ADM') {
				//Admission lines may not be selected
				$window.alert(t['CancelOnlyInvoice']);
				return false;
			}
			if (BillType == '') {
				BillType = NextBillType;
			} else {
				if (BillType != NextBillType) {
					$window.alert(t['NoPatInsBill'] + '\n' + t['OnlySameBill']);
					return false;
				}
			}
			if (i < SelectedRows - 1) {
				BillRowIds = BillRowIds + '|';
				PatientIds = PatientIds + '|';
				EpisodeIds = EpisodeIds + '|';
			}
			i = i + 1;
		}
		lnk += '&PatientIDs=' + PatientIds + '&EpisodeIDs=' + EpisodeIds
			+ '&BillRowIDs=' + BillRowIds + '&CONTEXT=' + session['CONTEXT'];
		return true;
	};

	var aRPBillPrintSelectedBills = function() {
		var BillType = '';
		var BillRowID = '';
		var PatientID = '';
		var EpisodeID = '';
		var i = 1;
		var NextBillType;
		while (mPiece(frm.BillRowIds.value, '^', i) != '') {
			i = i + 1;
		}
		i = 1;
		while (mPiece(frm.BillRowIds.value, '^', i) != '') {
			BillRowID = BillRowID + mPiece(frm.BillRowIds.value, '^', i);
			EpisodeID = EpisodeID + frm.EpisodeID.value;
			PatientID = PatientID + frm.PatientID.value;
			BillType = mPiece(frm.BillTypes.value, '^', i);
			NextBillType = mPiece(frm.BillTypes.value, '^', i);
			if ((NextBillType != 'I') && (NextBillType != 'P')) {
				//bill type other than invoice has been selected.
				$window.alert(t['PrintInvoices']);
				return false;
			}
			if (BillType == '') {
				BillType = NextBillType;
			}
			if ((BillType != 'I') && (BillType != 'P')) {
				$window.alert(t['PrintInvoices']);
				return false;
			}
			//cheat to pass EpisodeID for print history description
			var arrParam = lnk.split('&prompt0=');
			lnk = arrParam[0] + '&BillRowID=' + BillRowID + '&PatientID=' + PatientID;
			lnk =
			i = i + 1;
		}
		return true;
	};

	var checkOpTheatreDetails = function() {
		if (frm.AnaesthesiaID.value != '') {
			// if there is an Anaesthesia row it cannot be requested anymore
		} else {
			if ((frm.apptID.value == '') || (frm.OperRoomID.value == '')) {
				$window.alert(t['ReqOTBooking']);
				return false;
			}
		}

		if (/Y/i.test(frm.Decease.value)) {
			if (!$window.confirm(t['PAT_DECEASED'])) return false;
		}
		return true;
	};

	var checkItemAppointmentDetails = function() {
		if (frm.ItemApptStatus.value != '') {
			$window.alert(t['APPT_EXIST']);
			return false;
		}
		if (/D/i.test(frm.OEORIItemStatus.value)) {
			$window.alert(t['DiscontinuedOrder']);
			return false;
		}
		if (/E/i.test(frm.OEORIItemStatus.value)) {
			$window.alert(t['ExecutedOrder']);
			return false;
		}
		if (/REP/i.test(frm.OEORIItemStatus.value)) {
			$window.alert(t['ExecutedOrder']);
			return false;
		}
		if (/TYP/i.test(frm.OEORIItemStatus.value)) {
			$window.alert(t['ExecutedOrder']);
			return false;
		}
		if (/RESV/i.test(frm.OEORIItemStatus.value)) {
			$window.alert(t['ExecutedOrder']);
			return false;
		}
		if (/IP/i.test(frm.OEORIItemStatus.value)) {
			$window.alert(t['ExecutedOrder']);
			return false;
		}
		if (/B/i.test(frm.OEORIItemStatus.value)) {
			$window.alert(t['CannotRebook']);
			return false;
		}
		if (/Y/i.test(frm.Decease.value)) {
			if (!$window.confirm(t['PAT_DECEASED'])) return false;
		}

		GlobalService.callFunction('OEOrdItem_RadiologyWorkBench_0',
									'CheckItemAppointmentDetailsWaitingListCheck', [],
									function(returnValue) {
										if (returnValue === false) return false;
									});
		lnk += '&OEOrdItemID=' + frm.OEOrdItemID.value;
		return true;
	};

	var checkCSLinkDetails = function() {
		var EpisodeID = frm.EpisodeID.value;
		if (/Y/i.test(frm.Decease.value)) {
			if (!$window.confirm(t['PAT_DECEASED'])) return false;
		}

		// get value of doctype to pass in
		var doctype = '';
		var start = 0;
		var end = 0;
		start = lnk.indexOf('&doctype=');
		if (start != -1) {
			start = start + 9;
			end = lnk.indexOf('&', start);
			if (end == -1) end = lnk.length;
			if (end != -1) doctype = lnk.substring(start, end);
		}

		if (doctype == '') {
			$window.alert(t['NoCSDocType']);
			return false;
		}

		// if we need to pass thru more request params, concatenate them to doctype
		var err = tkMakeServerCall('web.PAAdmDischargeSummary', 'SaveDSEpisodes', '', EpisodeID, '', doctype, 1);
		if (err != '') {
			if (err.substring(0, 1) == 0) {
				$window.alert(err.substring(2));
				return false;
			}
			if ((err.substring(0, 1) == 1) && (err.substring(2) != '')) {
				lnk = lnk + '&DischID=' + err.substring(2);
			}
		}

		lnk = lnk + '&DischEpisodes=' + EpisodeID;
		return true;
	};

	var checkPassOrderDetailsToACN = function() {
		var i;
		var OEOrdItemCorrespondingPatientIDs = frm.MultiPatientID.value;
		if (OEOrdItemCorrespondingPatientIDs === '') OEOrdItemCorrespondingPatientIDs = frm.PatientID.value;
		if (frm.OEOrdItemID.value == '' ||
			(OEOrdItemCorrespondingPatientIDs == '')) {
			$window.alert(t['NoOrderItems']);
			return false;
		}

		if (/Y/i.test(frm.Decease.value)) {
			if (!$window.confirm(t['PAT_DECEASED'])) return false;
		}

		//Make sure we only have 1 patient for all selected rows:
		var patients = OEOrdItemCorrespondingPatientIDs.split('^');
		if (OEOrdItemCorrespondingPatientIDs.endsWith('^')) {
			patients = patients.slice(0, -1);
		}

		frm.PatientID.value = patients[0];
		for (i = 0; i < patients.length; i++) {
			if ((frm.PatientID.value != patients[i]) && (patients[i] != '')) {
				$window.alert(t['OEOrdItemMultiplePatients']);
				return false;
			}
		}

		//Orders must all be from the same episode to attach to an ACN entry:
		var OEOrdItemCorrespondingEpisodeIDs = frm.MultiEpisodeID.value;
		if (OEOrdItemCorrespondingEpisodeIDs === '') OEOrdItemCorrespondingEpisodeIDs = frm.EpisodeID.value;
		var episodes = OEOrdItemCorrespondingEpisodeIDs.split('^');
		if (OEOrdItemCorrespondingEpisodeIDs.endsWith('^')) {
			episodes = episodes.slice(0, -1);
		}

		var firstEpisode = episodes[0];
		for (i = 0; i < episodes.length; i++)	{
			if ((firstEpisode != episodes[i]) && (episodes[i] != '')) {
				$window.alert(t['OEOrdItemMultipleEpisodes']);
				return false;
			}
		}

		//Orders may have status of Executed, postponed, verified, or In Progress
		var statuses = frm.OEORIItemStatus.value.split('^');
		//Deal with trailing ^ in form:
		if (frm.OEORIItemStatus.value.endsWith('^')) statuses = statuses.slice(0, -1);

		for (i = 0; i < statuses.length; i++)	{
			if ((patients[i] != '')
				&& (statuses[i] != 'RESV')
				&& (statuses[i] != 'E')
				&& (statuses[i] != 'S')
				&& (statuses[i] != 'V')
				&& (statuses[i] != 'IP')) {

				$window.alert(t['OEOrdItemValidOrderStatus']);
				return false;
			}
		}

		var desiredEncounterToOpen = tkMakeServerCall('web.MREncounter', 'GetEncounterLinkedToOEOrdItemIDs',
									frm.OEOrdItemID.value, frm.mradm.value, frm.ContactID.value, frm.apptID.value);
		if (desiredEncounterToOpen) {
			lnk += '&MREncounterID=' + desiredEncounterToOpen;
		} else {
			//No valid encounter for these items.
			$window.alert(t['OEOrdItemCouldNotFindEncounter']);
			return false;
		}

		return true;
	};

	var passDetailsExceptEpis = function() {
		frm.EpisodeID.value = '';
		lnk += '&EpisodeID=';

		if (frm.MultipleIDs.value) lnk += '&TWKFLL=' + frm.MultipleIDs.value;

		lnk += '&PatientID=' + frm.PatientID.value;
		if (frm.OEOrdItemID.value) lnk += '&OEOrdItemID=' + frm.OEOrdItemID.value;

		return true;
	};

	var checkAttendance = function() {
		if (frm.attendID.value == '') {
			$window.alert(t['NOAttend']);
			return false;
		}

		lnk += '&attendID=' + frm.attendID.value + '&ID=' + frm.EpisodeID.value;

		return true;
	};

	this.checkFunctions = {
		CheckLinkDetailsMulti: checkLinkDetailsMulti,
		CheckOrderItemDetails: checkOrderItemDetails,
		CheckLinkDetailsVoice: checkLinkDetailsVoice,
		CheckLinkDetailsBatchVoice: checkLinkDetailsBatchVoice,
		CheckLinkDetailsBatchText: checkLinkDetailsBatchText,
		CheckLinkDetailsforWordDoc: checkLinkDetailsforWordDoc,
		CheckLinkDetailsforFastWordDoc: checkLinkDetailsforFastWordDoc,
		CheckLinkDetailsforWordDocVerify: checkLinkDetailsforWordDocVerify,
		CheckLinkDetailsforText: checkLinkDetailsforText,
		CheckLinkDetailsforFastText: checkLinkDetailsforFastText,
		CheckLinkDetailsforFastQuest: checkLinkDetailsforFastQuest,
		CheckLinkDetailsforTextVerify: checkLinkDetailsforTextVerify,
		CheckLinkDetailsforDelivery: checkLinkDetailsforDelivery,
		CheckWLAddDetails: checkWLAddDetails,
		CheckOrderItemAndSubCategory: checkOrderItemAndSubCategory,
		CheckWaitingListDetails: checkWaitingListDetails,
		CheckWaitingListAdmDetails: checkWaitingListDetails,
		CheckEpisodeDetailsforApp: checkEpisodeDetailsforApp,
		CheckWaitingListStatusDetails: checkWaitingListStatusDetails,
		CheckWaitingListOTDetails: checkWaitingListOTDetails,
		CheckNewBornLinkDetails: checkNewBornLinkDetails,
		'ARPBill_CancelSelectedBills': aRPBillCancelSelectedBills, /* Deprecated */
		'ARPBill_PrintSelectedBills': aRPBillPrintSelectedBills,  /* Deprecated */
		CheckOpTheatreDetails: checkOpTheatreDetails,
		CheckItemAppointmentDetails: checkItemAppointmentDetails,
		CheckCSLinkDetails: checkCSLinkDetails,
		PassOrderDetailsToACN: checkPassOrderDetailsToACN, /* Deprecated */
		CheckPassOrderDetailsToACN: checkPassOrderDetailsToACN,
		PassDetailsExceptEpis: passDetailsExceptEpis,
		CheckAttendance: checkAttendance,
		CheckLabEpisodeDetails: checkLabEpisodeDetails
	};
});
